import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, Menu } from 'antd';

class ResendRecordsMenu extends PureComponent {
  render() {
    const {
      openMenu,
      handleResendRecord,
      handleRequestChange,
      disableSingleResend,
      singleResendBlocked,
      children,
    } = this.props;
    const overlay = (
      <Menu onClick={handleResendRecord}>
        <Menu.Item key="1" disabled={disableSingleResend || singleResendBlocked}>
          {/* ENG-3340: the server blocks a resend while the fax is still being sent. */}
          {singleResendBlocked ? 'Resend selected record (still being sent, try again later)' : 'Resend selected record'}
        </Menu.Item>
        <Menu.Item key="3" disabled={!disableSingleResend}>Resend all records not viewed in 3 Days</Menu.Item>
        <Menu.Item key="7" disabled={!disableSingleResend}>Resend all records not viewed in 7 Days</Menu.Item>
        <Menu.Item key="10" disabled={!disableSingleResend}>Resend all records not viewed in 10 Days</Menu.Item>
      </Menu>
    );
    return (
      <Dropdown
        overlay={overlay}
        visible={openMenu}
        onVisibleChange={handleRequestChange}
        trigger={['click']}
        placement="bottomRight"
      >
        {children}
      </Dropdown>
    );
  }
}

ResendRecordsMenu.defaultProps = {
  singleResendBlocked: false,
};

ResendRecordsMenu.propTypes = {
  handleResendRecord: PropTypes.func.isRequired,
  handleRequestChange: PropTypes.func.isRequired,
  openMenu: PropTypes.bool.isRequired,
  disableSingleResend: PropTypes.bool.isRequired,
  singleResendBlocked: PropTypes.bool,
  children: PropTypes.node.isRequired,

};

export default ResendRecordsMenu;
